const hostname = window.location.hostname;

let BACKEND_ENDPOINT = "https://dev-server.p-url.com"; // default

if (hostname === "app.p-url.com") {
  BACKEND_ENDPOINT = "https://api-server.p-url.com";
} else if (hostname === "app-development.p-url.com") {
  BACKEND_ENDPOINT = "https://dev-server.p-url.com";
}

export { BACKEND_ENDPOINT };

const PUBLIC_HOST = "app";
const currentDomain = hostname.split(".")[0];

export const isValidPublicDomain = currentDomain === PUBLIC_HOST;

export const purlPlans = [
  {
    0: "shellpackage",
    1: "oysterpackage",
    2: "pearlpackage",
  },
];

export const purlPackages = [
  { plan: "oysterpackage", amount: "£3.99" },
  { plan: "pearlpackage", amount: "£19.99" },
];
